var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col-md-12 h-90 w-100 overflow-y-scroll px-0" },
    [
      _c("b-overlay", { attrs: { show: _vm.loading } }, [
        _c("table", { staticClass: "w-100 rounded" }, [
          _c(
            "thead",
            { staticClass: "fb-bg-primary", staticStyle: { color: "white" } },
            [
              _c("tr", [
                _c("th", [_vm._v("Estado")]),
                _c("th", [_vm._v("Nombre")]),
                _c("th", { staticClass: "text-center" }, [_vm._v("Tamaño")]),
                _c("th", [_vm._v("Fecha Creación")]),
                _c("th", [_vm._v("Propietario")])
              ])
            ]
          ),
          !_vm.loadingElements
            ? _c(
                "tbody",
                { attrs: { id: "folder-elements" } },
                [
                  _vm._l(_vm.folderElements, function(element) {
                    return _c("rs-navigation-element", {
                      key: element.id,
                      attrs: { element: element, "data-cy": "folder" }
                    })
                  }),
                  _vm._l(_vm.fileElements, function(element) {
                    return _c("rs-navigation-element", {
                      key: element.id,
                      attrs: { element: element, "data-cy": "file" }
                    })
                  }),
                  _vm.isEmptyFolder
                    ? _c("tr", [
                        _c("td", { attrs: { colspan: "5" } }, [
                          _c(
                            "div",
                            { staticClass: "d-flex justify-center m-5" },
                            [
                              _c("span", [
                                _vm._v("Ups! esta carpeta está vacía.")
                              ])
                            ]
                          )
                        ])
                      ])
                    : _vm._e()
                ],
                2
              )
            : _c(
                "tbody",
                [
                  _vm.loadingElements
                    ? _c("tr", [
                        _c("td", { staticClass: "opacity-0" }, [_vm._v(".")])
                      ])
                    : _vm._e(),
                  _vm._l(_vm.loadingElements ? 5 : 0, function(i) {
                    return _c(
                      "tr",
                      { key: i },
                      _vm._l(5, function(i) {
                        return _c(
                          "td",
                          { key: i, staticClass: "px-2" },
                          [
                            _c("b-skeleton", {
                              staticClass: "bg-grey-light w-100",
                              attrs: { animation: "fade" }
                            })
                          ],
                          1
                        )
                      }),
                      0
                    )
                  })
                ],
                2
              )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }